class ReviewsReadMore {

    //#region constructor

        constructor() {

            // 'Read More' buttons method binding
            this.toggleReadMore = this.toggleReadMore.bind(this);

        }

    //#endregion

    //#region Reviews 'Read More' 

        // Toggle between displaying truncated and full review text
        toggleReadMore(button) {
            const parent = button.parentNode;
            const isOpen = parent.classList.toggle('open');
            button.innerText = isOpen ? 'Read less...' : 'Read all...';
        }

    //#endregion

}

// Check for instance of reviews before class
const reviewsContainer = document.querySelector("body.cottage #reviews");
if (reviewsContainer) {

    // Create an instance of the Reviews class
    const readMore = new ReviewsReadMore();

    //#region Add Click Events 

        const handleReadMoreClick = (event) => {
            const target = event.target;
            if (target.classList.contains('read-more-btn')) {
                // Toggle between displaying truncated and full review text
                readMore.toggleReadMore(target);
            }
        };

        // Attach onclick event for 'Read More' buttons on readMore
        reviewsContainer.addEventListener('click', handleReadMoreClick);

    //#endregion
}
